import { createFileRoute } from "@tanstack/react-router";
import AdminDataConsistency from "@/pages/AdminDataConsistency";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/data-consistency/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="Data Consistency Checks"><AdminDataConsistency /></RoleGate>
  ),
});
